import * as angular from 'angular';
import {IHttpService} from 'angular';
import {getDocumentTypes, TSDocumentType} from '../../models/enums/TSDokumentType';
import TSDokument from '../../models/TSDokument';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;

export default class DokumenteRS {
    serviceURL: string;
    http: IHttpService;
    log: ILogService;
    private _fileTypeMap: Map<TSDocumentType, Set<string>>;

    static $inject = ['$http', 'REST_API', '$log'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, $log: ILogService) {
        this.serviceURL = REST_API + 'dokumente';
        this.http = $http;
        this.log = $log;

        this._fileTypeMap = new Map<TSDocumentType, Set<string>>();
        getDocumentTypes().forEach(docType => {
            this._fileTypeMap.set(docType, new Set<string>([
                'image/jpeg',
                'image/png',
                'image/svg+xml',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ]));
        });
    }

    public findDocuments(fallId: string, doctype: TSDocumentType, parentId?: string) {

        //parentId is not always set > pass as query param
        let url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/' + encodeURIComponent(TSDocumentType[doctype]);
        if (parentId !== undefined) {
            url = url += '?parentId=' + parentId;
        }

        return this.http.get(url)
            .then((response: any) => {
                this.log.debug('PARSING documentDTO REST object ', response.data);
                let converter = (jsonString: any) => {
                    return new TSDokument().deserialize(jsonString);
                };
                if (angular.isArray(response.data)) {
                    return response.data.map(converter);
                }
                return [];
            });

    }

    public deleteDocument(fallId: string, doctype: TSDocumentType, documentId: string,
                          parentId: string): IPromise<any> {
        let url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/'
            + encodeURIComponent(TSDocumentType[doctype]) + '/doc/' + encodeURIComponent(documentId);
        if (parentId) {
            url = url + '?parentId=' + encodeURIComponent(parentId);
        }
        return this.http.delete(url)
            .then((response) => {
                return response;
            });
    }

    public isFileTypeAllowedForDocumentType(fileType: string, docType: TSDocumentType): boolean {
        let docTypeSet: Set<string> | undefined = this._fileTypeMap.get(docType);
        if (docTypeSet !== undefined) {
            return docTypeSet.has(fileType);
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/dokumenteRS.rest.ts